export const filterNulls = <T>(arr: T[]) => arr.filter(q => q !== null) as NonNullable<T>[];

export const splitArrayBy = <T>(
  array: T[],
  predicate: (item: T, index: number, array: T[]) => boolean,
): [T[], T[]] => {
  return [
    array.filter(predicate),
    array.filter((item, index, arr) => !predicate(item, index, arr)),
  ];
};
